import type { SoundEffect } from "../../lib/sound.ts";

export type TeamCountdownSecond = 1 | 2 | 3;

export interface TeamMatchClock {
  started: boolean;
  remainingMs: number;
  countdownSecond: TeamCountdownSecond | null;
}

/**
 * Maç saati geri sayım boyunca tam sürede bekler. Hem oyuncu girdisi hem de
 * ekrandaki sayaç aynı `started` değerini kullandığı için istemci tarafında
 * erken başlama oluşmaz.
 */
export function teamMatchClock(startsAt: number, endsAt: number, now: number): TeamMatchClock {
  const started = now >= startsAt;
  const countdownMs = Math.max(0, startsAt - now);
  const countdownSecond = started
    ? null
    : Math.min(3, Math.max(1, Math.ceil(countdownMs / 1000))) as TeamCountdownSecond;

  return {
    started,
    remainingMs: Math.max(0, endsAt - Math.max(now, startsAt)),
    countdownSecond,
  };
}

export interface TeamCountdownAudioState {
  matchId: string | null;
  second: TeamCountdownSecond | null;
}

interface TeamCountdownAudioFrame {
  matchId: string;
  second: TeamCountdownSecond | null;
  visible: boolean;
}

export const EMPTY_TEAM_COUNTDOWN_AUDIO_STATE: TeamCountdownAudioState = {
  matchId: null,
  second: null,
};

/**
 * 200 ms'lik saat güncellemelerinde aynı sayıyı tekrar seslendirmez. Sekme
 * görünmüyorken geçilen sayılar tüketilmiş sayılır ve geri dönünce çalınmaz.
 */
export function advanceTeamCountdownAudio(
  state: TeamCountdownAudioState,
  frame: TeamCountdownAudioFrame,
): { state: TeamCountdownAudioState; effects: SoundEffect[] } {
  const changed = state.matchId !== frame.matchId || state.second !== frame.second;
  const effects: SoundEffect[] =
    changed && frame.second !== null && frame.visible ? ["countdown"] : [];

  return {
    state: { matchId: frame.matchId, second: frame.second },
    effects,
  };
}
